import { useLazyQuery } from '@apollo/client';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import { PATH, ProductListKey, ProductListText } from '~/constants/enum';
import { QUERY_TRACKING_CLICK_RELATED } from '~/data/product/gql';
import { Product, ProductVariant } from '~/services/product';
import { trackingProductView, trackingSelectItem } from '~/services/tracking';
import { getLocalStorage, removeLocalStorage } from '~/utils/local-storage';

type Props = {
    payload: {
        variant: Partial<ProductVariant>;
        product: Partial<Product>;
        qty: number;
        b?: number | ProductListKey | string;
        cartId?: string;
    };
};

const TrackingSSG = ({ payload }: Props) => {
    const { variant, product, qty: quantity, cartId } = payload;
    const router = useRouter();
    const query = router.query;

    /**
     * p is the index of the product in the list
     * b is the block id or the list key
     */
    const { b, p, search_query, type } = getLocalStorage(`${product.sku}`);

    const initViewItem = useRef(false);
    const [relatedTrackingClick] = useLazyQuery(QUERY_TRACKING_CLICK_RELATED, {
        onCompleted(data) {
            console.log('relatedTrackingClick', data);
        }
    });

    const initSelectTrackingMagento = useRef(false);

    useEffect(() => {
        const isValidTrackMagento = type === 'search' ? !!search_query : !Number.isNaN(Number(b));
        if (!!product?.sku && !!cartId && !!isValidTrackMagento && !initSelectTrackingMagento.current) {
            funcTrack();
        }
    }, [b, cartId, product?.sku, p, search_query, type]);

    const funcTrack = async () => {
        await trackingSelectItem({
            listKey: !!ProductListText[b as ProductListKey]
                ? ProductListText[b as ProductListKey]
                : type !== 'search'
                ? (b as any)
                : (search_query as string),
            product: product,
            index: Number.isNaN(p) ? 0 : Number(p)
        });
        await relatedTrackingClick({
            variables: {
                block_id: type === 'search' ? undefined : b,
                sku: product?.sku,
                cartId,
                type: type,
                search_query: type !== 'search' ? undefined : search_query
            }
        });
        initSelectTrackingMagento.current = true;
        removeLocalStorage(`${product.sku}`);
        // router.push(
        //     {
        //         pathname: PATH.ProductDetail,
        //         query: {
        //             slug: product?.url_key,
        //             variant: query?.variant
        //         }
        //     },
        //     undefined,
        //     { shallow: true }
        // );
    };

    useEffect(() => {
        if (isEmpty(product) || isEmpty(variant) || !!initViewItem.current) return;
        trackingProductView({
            variant,
            product,
            qty: quantity
        });

        initViewItem.current = true;
    }, [variant, product, quantity]);
    return <div></div>;
};

export default TrackingSSG;
